import Vue from 'vue'
import LazyLoad from './lazyLoad'
import ToolTip from './toolTip'
import Visible from './visible'
import OnlyNumber from './onlyNumber'
import Placeholder from './placeholder'
import Map from './map'
import playOnClick from './playOnClick'
import imgSize from './imgSize'
import selectOnClick from './selectOnClick'
import animationZoomBounce from './animationZoomBounce'

Vue.directive('lazyload', LazyLoad)
Vue.directive('tooltip', ToolTip)
Vue.directive('visible', Visible)
Vue.directive('onlynumber', OnlyNumber)
Vue.directive('placeholder', Placeholder)
Vue.directive('map', Map)
Vue.directive('play-on-click', playOnClick)
Vue.directive('img-size', imgSize)
Vue.directive('select-on-click', selectOnClick)
Vue.directive('animation-zoom-bounce', animationZoomBounce)
